import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress } from '@mui/material';

const EditUserModal = ({ isOpen = false, onClose, user, onSave }) => {
  const [userData, setUserData] = useState({
    username: '',
    email: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setUserData({
        username: user.username || '',
        email: user.email || '',
        password: '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setIsLoading(true);
    await onSave(userData);
    setIsLoading(false);
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Editar Usuario</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <>
            <TextField
              autoFocus
              margin="dense"
              name="username"
              label="Nombre de usuario"
              type="text"
              fullWidth
              variant="standard"
              value={userData.username}
              onChange={handleChange}
            />
            <TextField
              margin="dense"
              name="email"
              label="Correo electrónico"
              type="email"
              fullWidth
              variant="standard"
              value={userData.email}
             onChange={handleChange}
           />
           <TextField
             margin="dense"
             name="password"
             label="Nueva Contraseña"
             type="password"
             fullWidth
             variant="standard"
             value={userData.password}
             onChange={handleChange}
           />
         </>
       )}
     </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSave} disabled={isLoading}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserModal;
